import { render, staticRenderFns } from "./addressee.vue?vue&type=template&id=a69f1738&scoped=true&"
import script from "./addressee.vue?vue&type=script&lang=js&"
export * from "./addressee.vue?vue&type=script&lang=js&"
import style0 from "./addressee.vue?vue&type=style&index=0&id=a69f1738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69f1738",
  null
  
)

export default component.exports